import React, { useState } from "react";
import { Link } from "react-router-dom";
import { requestPasswordReset } from "../api/AuthAPI";
import { getUserMessage, logApiError } from "../api/apiError";

const ForgotPasswordForm: React.FC = () => {
    const [email, setEmail]     = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError]     = useState<string | null>(null);
    const [sent, setSent]       = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError(null);
        setLoading(true);
        try {
            await requestPasswordReset(email.trim());
            setSent(true);
        } catch (err) {
            logApiError(err);
            setError(getUserMessage(err));
        } finally {
            setLoading(false);
        }
    };

    if (sent) {
        return (
            <div className="auth-card">
                <h2>Check your email</h2>
                <p className="subtitle">
                    If an account exists for <strong>{email}</strong>, a reset link has been sent.
                    The link expires in 5 minutes.
                </p>
                <Link to="/" className="btn-outline" style={{ marginTop: "1rem", display: "inline-block" }}>
                    Back to Sign In
                </Link>
            </div>
        );
    }

    return (
        <div className="auth-card">
            <h2>Forgot Password</h2>
            <p className="subtitle">Enter your email and we'll send you a reset link.</p>
            <form onSubmit={handleSubmit} className="auth-form">
                <div className="form-group">
                    <label htmlFor="email">Email Address</label>
                    <input
                        type="email"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Enter your email"
                        required
                        disabled={loading}
                    />
                </div>
                <button type="submit" disabled={loading || !email.trim()}>
                    {loading ? "Sending…" : "Send Reset Link"}
                </button>
                {error && <p className="error-message">{error}</p>}
            </form>
            <div style={{ marginTop: "1rem", textAlign: "center" }}>
                <Link to="/">Back to Sign In</Link>
            </div>
        </div>
    );
};

export default ForgotPasswordForm;
